import KoobInputSelect from './KoobInputSelect';

export interface KoobOrganizationPickerOption {
  organizationId: string | number;
  displayName: string;
  isGroup?: boolean;
}

interface KoobOrganizationPickerProps {
  organizations: KoobOrganizationPickerOption[];
  currentOrganizationId?: string | number;
  onChange: (organizationId: string) => void;
  label: string;
  /** Label of a group, which stands for all its organizations. */
  groupLabel: (name: string) => string;
  className?: string;
}

// Past this many organizations the list gets a search field.
const SEARCHABLE_FROM = 6;

/**
 * The one organization picker of the app (KD-3735): which of the user's
 * organizations every screen acts as. Hidden for users in one organization.
 */
export default function KoobOrganizationPicker({
  organizations,
  currentOrganizationId,
  onChange,
  label,
  groupLabel,
  className,
}: KoobOrganizationPickerProps) {
  if (organizations.length < 2) return null;

  return (
    <div className={className}>
      <KoobInputSelect
        label={label}
        size="sm"
        searchable={organizations.length >= SEARCHABLE_FROM}
        value={
          currentOrganizationId === undefined
            ? null
            : String(currentOrganizationId)
        }
        onValueChange={(value) => onChange(String(value))}
        options={organizations.map((organization) => ({
          value: String(organization.organizationId),
          label: organization.isGroup
            ? groupLabel(organization.displayName)
            : organization.displayName,
        }))}
      />
    </div>
  );
}
